import AuthenticationService from '@/services/authentication';
import statusCodes from '@/constants/statusCodes';
import store from '@/store';
import { pushAlert } from './messages/alertService';
import {
  getMessagesFromResponseError,
  getMessagesFromTusResponseError,
} from './apiResponses/errorResponses';

function shouldIgnoreError(options, error) {
  const param = options.ignore;
  if (typeof param === 'function') {
    return param(error);
  }
  return !!param;
}

export function handleError(error, { dataSelector, responseMessageParams } = {}) {
  const messages = getMessagesFromResponseError(error,
    responseMessageParams,
    dataSelector);

  messages.forEach(pushAlert);
}

function hideError(hideErrorFunc, error) {
  return hideErrorFunc && hideErrorFunc(error);
}

/**
 *
 * @param {Object} options Opções de controle de erro.
 * @param {Object} error Erro de requisição emitido pelo Axios.
 * @param {Function} [options.dataSelector] Função que filtra o erro,
 * extraindo o objeto de erro da API de dentro dos dados da requisição.
 * @param {Boolean|Function} [options.ignore] Booleano que ativa/desativa o controle de erro
 * ou função "(error) => bool" que avaliar se deve ignorar o erro.
 * @param {Object|Function} [options.responseMessageParams] Configuração de formatação de
 * parametros de mensagens.
 */
export function handleResponseError(options, error) {
  // Se não foi possível fazer o refresh do token, não exibe múltiplos toasts de erro
  if (store.getters.isRefreshTokenExpired) {
    const promise = Promise.reject(error);
    promise.catch(() => null);
    return promise;
  }

  if (!error.$handled && !hideError(options.hideError, error)) {
    if (!shouldIgnoreError(options, error)) {
      // eslint-disable-next-line no-param-reassign
      error.$handled = true;
      handleError(error, options);
    }
  }

  const promise = Promise.reject(error);
  // Evitando erro de console quando não for necessário tratar erro de requisição.
  promise.catch(() => null);
  return promise;
}

/**
 *
 * @param {Object} options Opções de controle de erro.
 * @param {Object} tusError Erro de requisição emitido pelo Tus.
 * @param {Boolean|Function} [options.ignore] Booleano que ativa/desativa o controle de erro
 * ou função "(error) => bool" que avaliar se deve ignorarar o erro.
 * @param {Object|Function} [options.responseMessageParams] Configuração de formatação de
 * parametros de mensagens.
 */
export function handleTusResponseError(options, tusError) {
  if (shouldIgnoreError(options, tusError)) {
    return;
  }

  if (tusError.originalRequest?.status === statusCodes.UNAUTHORIZED) {
    AuthenticationService.redirectToLogin(true); // TODO Ajustar refresh do TUS
    return;
  }
  const messages = getMessagesFromTusResponseError(tusError, options.responseMessageParams);

  messages.forEach(pushAlert);
}

export default {
  handleResponseError,
};
